import { render, staticRenderFns } from "./rfp-list.vue?vue&type=template&id=2a5eb577&scoped=true&"
import script from "./rfp-list.vue?vue&type=script&lang=js&"
export * from "./rfp-list.vue?vue&type=script&lang=js&"
import style0 from "./rfp-list.vue?vue&type=style&index=0&id=2a5eb577&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5eb577",
  null
  
)

export default component.exports